import React, { useContext } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import GroupDCT from "../FieldTags/GroupDCT";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const validationStatuses = [
    "Awaiting Data",
    "Data Received",
    "Issues Requiring Resolution",
    "Validation Complete",
    "Validation Not Required",
];

const ValidationStatus = ({ validationStatus, handleChange, pullLists, informedConsent, informedConsentApprover, shipmentFromRepo, sampleDisposal }) => {
    const { user } = useContext(UserContext);
    const canEdit = ((shipmentFromRepo === "No" && sampleDisposal === "No") || (informedConsent !== "No" && informedConsentApprover !== "No")) && checkRole(user, [ROLES.DCT]);

    return (
        <div className="planField">
            <GroupDCT />
            <FormControl variant="standard">
                <InputLabel>{pullListLabels.validationStatus}</InputLabel>
                <Select
                    id="validationStatus-field"
                    name="validationStatus"
                    InputLabelProps={{ shrink: true }}
                    value={validationStatus ? validationStatus : ""}
                    onChange={(e) => handleChange("validationStatus", e.target.value)}
                    disabled={!canEdit}
                >
                    {validationStatuses.map((status) => (
                        <MenuItem key={status} value={status}>
                            {status}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <HistoryLogElement pullLists={pullLists} label={"validationStatus"} />
        </div>
    );
};

export default ValidationStatus;